import { OpenSlackButton } from '@/modules/integrations/components/OpenSlackButton';
import Container from '@/modules/ui/components/container/Container';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

import { SlackConnectResult } from './SlackConnectResult';

export const RecruiterSlackConnectResult = () => {
  const currentUserQuery = useCurrentUserQuery();

  const externalAccountsPath = currentUserQuery.data?.id
    ? `/users/${currentUserQuery.data.id}/external-accounts`
    : '/jobs';

  return (
    <Container>
      <SlackConnectResult
        goBackPath={externalAccountsPath}
        renderActions={({ appId, teamId, goBackButton }) => (
          <>
            {appId && <OpenSlackButton target={{ appId, teamId }} />}
            {goBackButton}
          </>
        )}
      />
    </Container>
  );
};
